export const artworks = [
    { id: 'art-04', wide: true, cat: ['street'], fr: 'La Route au Crépuscule', en: 'The Road at Dusk' },
    { id: 'art-05', wide: true, cat: ['river'], fr: 'Matin sur la Rivière', en: 'Morning on the River' },
    { id: 'art-06', wide: true, cat: ['street'], fr: 'Chemin des Champs', en: 'The Field Path' },
    { id: 'art-07', wide: false, cat: ['mountain'], fr: 'La Maison du Vallon', en: 'The Valley House' },
    { id: 'art-08', wide: true, cat: [], fr: "Arbres d'Hiver", en: 'Winter Trees' },
    { id: 'art-09', wide: true, cat: ['mountain'], fr: 'Vers les Cimes', en: 'Towards the Peaks' },
    { id: 'art-10', wide: false, cat: ['river'], fr: "Reflets d'Automne", en: 'Autumn Reflections' },
    { id: 'art-11', wide: true, cat: ['mountain'], fr: "Vallée d'Or", en: 'Golden Valley' },
    { id: 'art-12', wide: true, cat: ['river'], fr: 'Rive Tranquille', en: 'The Quiet Bank' },
    { id: 'art-13', wide: true, cat: ['mountain'], fr: 'Premières Neiges', en: 'First Snows' },
    { id: 'art-14', wide: true, cat: ['river'], fr: "L'Étang Vert", en: 'The Green Pond' },
    { id: 'art-15', wide: true, cat: [], fr: 'Sous-Bois au Soir', en: 'Evening Woodland' },
    { id: 'art-16', wide: false, cat: ['street'], fr: 'Route de Campagne', en: 'Country Road' },
    { id: 'art-17', wide: false, cat: ['river', 'street'], fr: "Maisons au Bord de l'Eau", en: 'Houses by the Water' },
    { id: 'art-18', wide: true, cat: ['street'], fr: "L'Église, Matin d'Hiver", en: 'The Church, Winter Morning' },
    { id: 'art-19', wide: false, cat: ['mountain', 'river'], fr: 'Les Gorges en Été', en: 'Summer Gorges' },
    { id: 'art-20', wide: true, cat: ['river'], fr: "Lac d'Hiver", en: 'Winter Lake' },
    { id: 'art-21', wide: true, cat: ['river'], fr: 'Aube sur le Port', en: 'Dawn over the Harbour' },
    { id: 'art-22', wide: true, cat: ['mountain', 'street'], fr: 'Le Village sous les Cimes', en: 'The Village beneath the Peaks' },
    { id: 'art-23', wide: false, cat: ['river', 'street'], fr: "Le Village sur l'Eau", en: 'The Village on the Water' },
    { id: 'art-24', wide: true, cat: [], fr: 'Prairie en Fleurs', en: 'Meadow in Bloom' },
    { id: 'art-25', wide: true, cat: ['street'], fr: 'La Maison Rouge', en: 'The Red House' },
    { id: 'art-26', wide: true, cat: ['mountain'], fr: 'Forêt de Montagne', en: 'Mountain Forest' },
    { id: 'art-27', wide: true, cat: ['river'], fr: 'Le Vieux Pont', en: 'The Old Bridge' },
    { id: 'art-28', wide: true, cat: ['street'], fr: 'Le Village au Printemps', en: 'The Village in Spring' },
    { id: 'art-29', wide: true, cat: ['river'], fr: "Brume sur l'Eau", en: 'Mist on the Water' },
    { id: 'art-30', wide: true, cat: ['mountain'], fr: 'Vallée en Hiver', en: 'Valley in Winter' },
    { id: 'art-31', wide: true, cat: ['street'], fr: 'La Ferme Bleue', en: 'The Blue Farm' },
];

export const galleryFilters = [
    { key: 'all', fr: 'Tout', en: 'All' },
    { key: 'street', fr: 'Scènes de rue', en: 'Street scenes' },
    { key: 'river', fr: 'Scènes de rivière', en: 'River scenes' },
    { key: 'mountain', fr: 'Montagnes', en: 'Mountains' },
];

export const cv = {
    fr: {
        title: 'Curriculum vitæ',
        intro: "Peintre de plein air et enseignant en arts plastiques. Formé au Royaume-Uni, il enseigne aujourd'hui en Ariège et expose régulièrement en France.",
        sections: [
            {
                heading: 'Formation',
                items: [
                    "Bath Spa University — Certificat de troisième cycle en enseignement (Arts plastiques et design), 2006–2007",
                    "Falmouth College of Arts — Licence avec mention (Illustration), 1999–2002",
                    "Bath College of Higher Education — HND, Foundation Studies en arts et design, 1998–1999",
                ],
            },
            {
                heading: "Expérience d'enseignement",
                items: [
                    "École Pleine Nature, Moulis — Professeur d'arts plastiques et de musique (2017–présent)",
                    "Association Ateliers Temps Libres, Aspet — Ateliers de pratiques artistiques (2017)",
                    "St. Crispin's Secondary School, Wokingham — Enseignant d'arts plastiques et de design (2007–2016)",
                ],
            },
            {
                heading: 'Expositions & prix',
                items: [
                    "2025 — Exposition collective, Maison de la Citoyenneté, Saint-Girons (nov.–déc.)",
                    "2025 — Exposition personnelle, Maison de la Citoyenneté, Saint-Girons",
                    "2025 — Artiste d'honneur, Week-end des arts de Castillan-en-Couserans",
                    "2024 — Exposition collective, Week-end des arts de Castillan-en-Couserans",
                    "2023 — Exposition collective, Maison de la Citoyenneté, Saint-Girons (nov.–déc.)",
                    "2023 — Exposition personnelle, espaces galerie de La Trapp Sens Boutique, Saint-Girons",
                    "2018 — Exposition personnelle (115 œuvres), Mairie d'Arbas",
                    "2017 — Événement collectif d'arts, Salies-du-Salat, Salinea",
                    "2017 — Place du marché d'Aspet, Festival collectif des villages (portraits)",
                    "2017 — « Aspet s'expose », Salle de vote et vitrines de la Grand Rue",
                    "2016 — « More Arts », Wokingham (exposition sur la santé mentale), exposition principale",
                    "2016 — Foire d'art du conseil municipal de Wokingham, exposition collective",
                    "2014–2015 — The Goring Gallery, exposition collective",
                    "2012–2014 — Henley Arts and Crafts Guild, exposition collective annuelle (3 années consécutives)",
                    "2011 — Lauréat du prix Mollie Staley, Henley Arts and Crafts Guild, exposition collective",
                    "2009 — Exposition collective, No 5 St Andrews Road, Henley-on-Thames",
                    "2002 — Exposition de fin d'études (Illustration), Falmouth College of Arts",
                    "2001 — Exposition collective, Falmouth Arts Centre",
                    "1999 — Exposition collective, Bath Arts College Foundation",
                    "1999 — Prêt d'une œuvre unique au consulat britannique, Sofia, Bulgarie",
                ],
            },
        ],
    },
    en: {
        title: 'Curriculum vitæ',
        intro: 'Plein air painter and art teacher. Trained in the United Kingdom, he now teaches in Ariège and exhibits regularly in France.',
        sections: [
            {
                heading: 'Education',
                items: [
                    'Bath Spa University — Post Graduate Certificate in Education (Art and Design), 2006–2007',
                    'Falmouth College of Arts — BA (Hons) Illustration, 1999–2002',
                    'Bath College of Higher Education — HND, Foundation Studies in Art and Design, 1998–1999',
                ],
            },
            {
                heading: 'Teaching experience',
                items: [
                    'École Pleine Nature, Moulis — Art and Music teacher (2017–present)',
                    'Association Ateliers Temps Libres, Aspet — Art practice workshops (2017)',
                    "St. Crispin's Secondary School, Wokingham — Art and Design teacher (2007–2016)",
                ],
            },
            {
                heading: 'Exhibitions & awards',
                items: [
                    '2025 — Group show, Maison de la Citoyenneté, Saint-Girons (Nov–Dec)',
                    '2025 — Solo show, Maison de la Citoyenneté, Saint-Girons',
                    '2025 — Guest of honour, Castillan-en-Couserans Arts Weekend',
                    '2024 — Group show, Castillan-en-Couserans Arts Weekend',
                    '2023 — Group show, Maison de la Citoyenneté, Saint-Girons (Nov–Dec)',
                    '2023 — Solo show, gallery spaces at La Trapp Sens Boutique, Saint-Girons',
                    "2018 — Solo show (115 works), Mairie d'Arbas",
                    '2017 — Collective arts event, Salies-du-Salat, Salinea',
                    '2017 — Aspet market square, Villages Collective Festival (portraits)',
                    "2017 — 'Aspet s'expose', voting hall and Grand Rue shop windows",
                    "2016 — 'More Arts', Wokingham (mental health exhibition), lead exhibition",
                    '2016 — Wokingham Town Council Art Fair, group show',
                    '2014–2015 — The Goring Gallery, group show',
                    '2012–2014 — Henley Arts and Crafts Guild, annual group show (three consecutive years)',
                    '2011 — Winner, Mollie Staley Prize, Henley Arts and Crafts Guild, group show',
                    '2009 — Group show, No 5 St Andrews Road, Henley-on-Thames',
                    '2002 — Degree show (Illustration), Falmouth College of Arts',
                    '2001 — Group show, Falmouth Arts Centre',
                    '1999 — Group show, Bath Arts College Foundation',
                    '1999 — Painting loaned to the British Consulate, Sofia, Bulgaria',
                ],
            },
        ],
    },
};

// All gallery artworks are also available as fine art prints.
// Slug matches the artwork id so /contact?ref=art-XX resolves cleanly.
export const prints = artworks.map((a) => ({
    slug: a.id,
    art: a.id,
    fr: a.fr,
    en: a.en,
}));

export const printSizes = [
    { label: '30 × 40 cm', price: 45 },
    { label: '40 × 50 cm', price: 75 },
    { label: '50 × 70 cm', price: 120 },
];

export const INSTAGRAM_URL = 'https://www.instagram.com/robinspencer.artist/?hl=en';

const wordsEn = [
    '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
    'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty',
    'twenty-one', 'twenty-two', 'twenty-three', 'twenty-four', 'twenty-five', 'twenty-six', 'twenty-seven', 'twenty-eight', 'twenty-nine', 'thirty',
];
const wordsFr = [
    '', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix',
    'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf', 'vingt',
    'vingt-et-un', 'vingt-deux', 'vingt-trois', 'vingt-quatre', 'vingt-cinq', 'vingt-six', 'vingt-sept', 'vingt-huit', 'vingt-neuf', 'trente',
];

export const numberWord = (n, lang = 'en') => {
    const arr = lang === 'fr' ? wordsFr : wordsEn;
    return arr[n] || String(n);
};

export const content = {
    fr: {
        nav: {
            home: 'Accueil',
            gallery: 'Galerie',
            about: 'À propos',
            cv: 'CV',
            shop: "Boutique d'Estampes",
            contact: 'Contact',
            donate: 'Soutenir',
            menu: 'Menu',
            close: 'Fermer',
        },
        hero: {
            kicker: 'Robin Spencer — Peintre de plein air',
            lines: ["La lumière,", "l'atmosphère,", 'le paysage.'],
            sub: 'Peintures réalisées sur le motif, entre aube et crépuscule.',
            ctaGallery: 'Voir la galerie',
            ctaShop: "Boutique d'estampes",
            scroll: 'Défiler',
        },
        home: {
            statement: "Peintre de plein air et enseignant en arts plastiques, dont le travail explore la lumière, l'atmosphère et le paysage à travers l'observation directe en extérieur.",
            readManifesto: 'Lire le manifeste',
            featuredTitle: 'Œuvres choisies',
            featuredSub: 'Une sélection de peintures récentes, peintes en extérieur.',
            viewAll: 'Toute la galerie',
            shopTitle: 'Estampes & tirages',
            shopSub: "Des tirages d'art de qualité musée, préparés à la commande. Les formats et tarifs disponibles ne sont pas encore affichés en ligne — écrivez à Robin pour en savoir plus.",
            shopCta: 'Découvrir les estampes',
            from: 'à partir de',
        },
        about: {
            title: 'À propos de Robin Spencer',
            intro: "Peintre de plein air et enseignant en arts plastiques, dont le travail explore la lumière, l'atmosphère et le paysage à travers l'observation directe en extérieur.",
            paragraph: "Peindre en extérieur est exaltant et complètement engageant. L'expérience en plein air est tellement riche que le travail à partir de photographies ou en atelier peut se révéler sans vie en comparaison. J'ai peint sous une chaleur accablante, dans le vent, dans la neige, et même de nuit en pleine tempête ; rien n'égale la sensation de connexion avec l'environnement, tous les sens stimulés, pour enregistrer les formes et les couleurs devant moi. Je suis très inspiré par la lumière optimiste de l'aube et par les tons doux du crépuscule. Être témoin de la nature telle qu'elle est me remplit entièrement, et je ressens le besoin de l'interpréter, un pinceau à la main.",
            chapters: [
                {
                    n: '01',
                    title: "L'appel du dehors",
                    text: "Peindre en extérieur est exaltant et complètement engageant. L'expérience en plein air est tellement riche que le travail à partir de photographies ou en atelier peut se révéler sans vie en comparaison.",
                },
                {
                    n: '02',
                    title: 'Les éléments',
                    text: "J'ai peint sous une chaleur accablante, dans le vent, dans la neige, et même de nuit en pleine tempête.",
                },
                {
                    n: '03',
                    title: 'La connexion',
                    text: "Rien n'égale la sensation de connexion avec l'environnement, tous les sens stimulés, pour enregistrer les formes et les couleurs devant moi.",
                },
                {
                    n: '04',
                    title: "L'aube et le crépuscule",
                    text: "Je suis très inspiré par la lumière optimiste de l'aube et par les tons doux du crépuscule. Être témoin de la nature telle qu'elle est me remplit entièrement, et je ressens le besoin de l'interpréter, un pinceau à la main.",
                },
            ],
            photoCaption1: "Sur le motif, devant le village.",
            photoCaption2: 'Travail en montagne, carnet à la main.',
            portraitCaption: 'Robin Spencer',
            portraitAlt: 'Portrait de Robin Spencer, chapeau de paille, devant ses toiles.',
        },
        gallery: {
            title: 'Galerie',
            sub: 'œuvres peintes sur le motif — cliquez pour agrandir',
            medium: 'Peint sur le motif · Plein air',
            filterLabel: 'Filtrer',
            empty: 'Aucune œuvre dans cette catégorie pour le moment.',
        },
        shop: {
            title: "Boutique d'Estampes",
            sub: "Tirages d'art numérotés, imprimés sur papier d'archive. Chaque estampe est préparée et signée à la main.",
            note: "Les tirages ne sont pas encore en vente en ligne. Pour connaître les formats et tarifs disponibles, ou pour passer commande, contactez Robin — il répondra personnellement.",
            enquire: 'Contacter Robin',
            contactRobin: 'Formats et tarifs sur demande — contactez Robin.',
            available: 'estampes disponibles',
            from: 'à partir de',
            sizeLabel: 'Formats',
        },
        contact: {
            title: 'Contact',
            sub: "Une question, une commande d'estampe, une visite d'atelier — écrivez-moi, je réponds personnellement à chaque message.",
            name: 'Votre nom',
            email: 'Votre e-mail',
            subject: 'Sujet (facultatif)',
            message: 'Votre message',
            send: 'Envoyer le message',
            sending: 'Envoi…',
            success: 'Message envoyé — merci ! Je vous répondrai très vite.',
            error: 'Une erreur est survenue. Merci de réessayer.',
            printInterest: "Je suis intéressé(e) par l'estampe",
            instagram: 'Retrouvez aussi mes dernières peintures et vidéos sur Instagram.',
        },
        donate: {
            title: 'Soutenir mon travail',
            body: "Merci de vouloir soutenir mon travail ! Les dons en ligne seront bientôt disponibles. En attendant, le plus beau soutien reste de partager mes peintures autour de vous et de me suivre sur Instagram.",
            follow: 'Suivre sur Instagram',
            close: 'Fermer',
        },
        footer: {
            instagram: "Cliquez sur l'icône Instagram pour découvrir mes dernières peintures et vidéos.",
            rights: 'Tous droits réservés',
        },
        instagram: {
            kicker: '03 — Instagram',
            title: 'Fraîchement peint',
            sub: 'Dernières œuvres, esquisses et vidéos, mises à jour automatiquement depuis Instagram.',
            error: "Impossible de charger le flux Instagram pour l'instant.",
            latest: 'Dernière publication',
            viewOnInstagram: 'Voir sur Instagram',
        },
        marquee: 'Robin Spencer — Peintre de plein air',
    },
    en: {
        nav: {
            home: 'Home',
            gallery: 'Gallery',
            about: 'About',
            cv: 'CV',
            shop: 'Prints Shop',
            contact: 'Contact',
            donate: 'Donate',
            menu: 'Menu',
            close: 'Close',
        },
        hero: {
            kicker: 'Robin Spencer — Plein Air Painter',
            lines: ['Light,', 'atmosphere,', 'landscape.'],
            sub: 'Paintings made on location, between dawn and dusk.',
            ctaGallery: 'View the gallery',
            ctaShop: 'Prints shop',
            scroll: 'Scroll',
        },
        home: {
            statement: 'Plein air painter and art teacher, whose work explores light, atmosphere, and landscape through direct observation outdoors.',
            readManifesto: 'Read the manifesto',
            featuredTitle: 'Selected works',
            featuredSub: 'A selection of recent paintings, painted outdoors.',
            viewAll: 'Full gallery',
            shopTitle: 'Prints & editions',
            shopSub: 'Museum-quality fine art prints, made to order. Sizes and prices are not listed online yet — write to Robin to learn more.',
            shopCta: 'Discover the prints',
            from: 'from',
        },
        about: {
            title: 'About Robin Spencer',
            intro: 'Plein air painter and art teacher, whose work explores light, atmosphere, and landscape through direct observation outdoors.',
            paragraph: "Painting outdoors is exhilarating and utterly absorbing. The plein air experience is so rich that working from photographs or in the studio can feel lifeless by comparison. I have painted in sweltering heat, in the wind, in the snow, and even at night in the middle of a storm; nothing equals the feeling of connection with one's surroundings — every sense alive, recording the shapes and colours before me. I am deeply inspired by the hopeful light of dawn and by the soft tones of dusk. To bear witness to nature as it is fills me completely, and I feel the need to interpret it, brush in hand.",
            chapters: [
                {
                    n: '01',
                    title: 'The call of the outdoors',
                    text: 'Painting outdoors is exhilarating and completely engaging. The plein air experience is so rich that working from photographs or in the studio can feel lifeless in comparison.',
                },
                {
                    n: '02',
                    title: 'The elements',
                    text: 'I have painted in sweltering heat, in the wind, in the snow, and even at night during a storm.',
                },
                {
                    n: '03',
                    title: 'The connection',
                    text: 'Nothing equals the sensation of connection with the environment, all senses stimulated, to record the shapes and colors before me.',
                },
                {
                    n: '04',
                    title: 'Dawn & dusk',
                    text: 'I am very inspired by the optimistic light of dawn and the soft tones of dusk. Witnessing nature as it is fulfills me entirely, and I feel the need to interpret it with a brush in hand.',
                },
            ],
            photoCaption1: 'On location, facing the village.',
            photoCaption2: 'Working in the mountains, sketchbook in hand.',
            portraitCaption: 'Robin Spencer',
            portraitAlt: 'Portrait of Robin Spencer, straw hat, in front of his paintings.',
        },
        gallery: {
            title: 'Gallery',
            sub: 'works painted on location — click to enlarge',
            medium: 'Painted on location · Plein air',
            filterLabel: 'Filter',
            empty: 'No works in this category yet.',
        },
        shop: {
            title: 'Prints Shop',
            sub: 'Numbered fine art prints on archival paper. Each print is prepared and hand-signed.',
            note: 'Prints are not yet available for online purchase. For sizes, pricing, and to order, please contact Robin — he replies personally.',
            enquire: 'Contact Robin',
            contactRobin: 'Sizes and pricing on request — contact Robin.',
            available: 'prints available',
            from: 'from',
            sizeLabel: 'Sizes',
        },
        contact: {
            title: 'Contact',
            sub: 'A question, a print order, a studio visit — write to me, I personally reply to every message.',
            name: 'Your name',
            email: 'Your email',
            subject: 'Subject (optional)',
            message: 'Your message',
            send: 'Send the message',
            sending: 'Sending…',
            success: 'Message sent — thank you! I will reply very soon.',
            error: 'Something went wrong. Please try again.',
            printInterest: 'I am interested in the print',
            instagram: 'You can also find my latest paintings and videos on Instagram.',
        },
        donate: {
            title: 'Support my work',
            body: 'Thank you for wanting to support my work! Online donations will be available soon. In the meantime, the greatest support is sharing my paintings around you and following me on Instagram.',
            follow: 'Follow on Instagram',
            close: 'Close',
        },
        footer: {
            instagram: 'Click the Instagram icon to discover my latest paintings and videos.',
            rights: 'All rights reserved',
        },
        instagram: {
            kicker: '03 — Instagram',
            title: 'Fresh off the easel',
            sub: 'Latest paintings, sketches, and videos — auto-updated from Instagram.',
            error: 'Instagram feed is unavailable right now.',
            latest: 'Latest post',
            viewOnInstagram: 'View on Instagram',
        },
        marquee: 'Robin Spencer — Plein Air Painter',
    },
};
